__turbopack_context__.v({
  "backgroundImageWrap": "TextRevealSection-module__zTU3QW__backgroundImageWrap",
  "backgroundLayer": "TextRevealSection-module__zTU3QW__backgroundLayer",
  "backgroundOverlay": "TextRevealSection-module__zTU3QW__backgroundOverlay",
  "scrollTrack": "TextRevealSection-module__zTU3QW__scrollTrack",
  "sectionRoot": "TextRevealSection-module__zTU3QW__sectionRoot",
  "solidBackground": "TextRevealSection-module__zTU3QW__solidBackground",
  "stickyViewport": "TextRevealSection-module__zTU3QW__stickyViewport",
  "text": "TextRevealSection-module__zTU3QW__text",
  "word": "TextRevealSection-module__zTU3QW__word",
});
